import React, { useEffect, useState } from "react";
import BoxComponent from "../../../../components/Box/BoxComponent";
import LabelComponent from "../../../../components/Label/LabelComponent";
import TextFieldComponent from "../../../../components/TextField/TextFieldComponent";
import { CampoPedidoInputStyle, CampoPedidoLabelStyle, CampoPedidoStyle } from "../modal/novo_pedido/InfoPedidoComponent";
import ButtonComponent from "../../../../components/Button/ButtonComponent";
import { UsuarioEnderecos } from "../../../../provider/auth/AuthProps";
import { Autocomplete, TextField } from "@mui/material";
import { MunicipioDTO, UfDTO } from "../../../../interface/Localidade";
import SelectComponent from "../../../../components/Select/SelectComponent";
import { localidadeService } from "../../../../service/LocalidadeService";

interface NovoEnderecoFieldsProps {
    token?: any;
    cancelaEndereco: () => void;
    onSubmit: (e: any) => void;
    endereco?: UsuarioEnderecos;
    onChange: (campo: string, valor: any) => void;

    /*
    municipios: MunicipioDTO[];
    municipio?: MunicipioDTO;
    onChangeMunicipio: (municipio: any) => void;

    ufs: UfDTO[]
    */
};

const NovoEnderecoFields = (props: NovoEnderecoFieldsProps) => {
    const [ufs, setUfs] = useState<UfDTO[]>([]);

    const [municipios, setMunicipios] = useState<MunicipioDTO[]>([]);
    const [municipio, setMunicipio] = useState<MunicipioDTO>();

    useEffect(() => {
        getUfs();
    }, [])

    const getUfs = async () => {
        try {
            const response = await localidadeService.getUfs();
            setUfs(response.data);
        } catch (err: any) {
            alert("Erro ao buscar as unidades da federação.");
        }
    }

    const getMunicipios = async (name: string) => {
        try {
            const response = await localidadeService.getMunicipios(name);
            setMunicipios(response.data);
        } catch (err: any) {
            alert("Erro ao buscar os municípios.");
        }
    }

    return <BoxComponent component="form" sx={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        gap: 2
    }}
        onSubmit={(e: any) => props.onSubmit(e)}
    >
        <BoxComponent component="div" sx={{ ...CampoPedidoStyle, px: 0, width: "100%" }}>
            <LabelComponent htmlFor="nome_endereco" sx={CampoPedidoLabelStyle}>
                Nome
            </LabelComponent>
            <TextFieldComponent
                id="nome_endereco"
                value={props.endereco?.nome || ""}
                onChange={e => props.onChange("nome", e.target.value)}
                fullWidth
                sx={{ ...CampoPedidoInputStyle }}
                required
            />
        </BoxComponent>
        <BoxComponent component="div" sx={{ ...CampoPedidoStyle, px: 0, flex: 2 }}>
            <LabelComponent htmlFor="rua_cliente" sx={CampoPedidoLabelStyle}>
                Rua
            </LabelComponent>
            <TextFieldComponent
                id="rua_cliente"
                value={props.endereco?.rua || ""}
                onChange={e => props.onChange("rua", e.target.value)}
                fullWidth
                sx={{ ...CampoPedidoInputStyle }}
                required
            />
        </BoxComponent>

        <BoxComponent component="div" sx={{ ...CampoPedidoStyle, px: 0, flex: 1 }}>
            <LabelComponent htmlFor="quadra_cliente" sx={CampoPedidoLabelStyle}>
                Quadra
            </LabelComponent>
            <TextFieldComponent
                id="quadra_cliente"
                placeholder=""
                value={props.endereco?.quadra}
                onChange={e => props.onChange("quadra", e.target.value)}
                fullWidth
                sx={{ ...CampoPedidoInputStyle }}
                required
            />
        </BoxComponent>

        <BoxComponent component="div" sx={{ ...CampoPedidoStyle, px: 0, flex: 1 }}>
            <LabelComponent htmlFor="numero_cliente" sx={CampoPedidoLabelStyle}>
                Número
            </LabelComponent>
            <TextFieldComponent
                id="numero_cliente"
                placeholder=""
                value={props.endereco?.numero}
                onChange={e => props.onChange("numero", e.target.value)}
                fullWidth
                sx={{ ...CampoPedidoInputStyle }}
            />
        </BoxComponent>

        <BoxComponent component="div" sx={{ ...CampoPedidoStyle, px: 0, width: "100%" }}>
            <LabelComponent htmlFor="complemento_cliente" sx={CampoPedidoLabelStyle}>
                Complemento
            </LabelComponent>
            <TextFieldComponent
                id="complemento_cliente"
                placeholder=""
                value={props.endereco?.complemento}
                onChange={e => props.onChange("complemento", e.target.value)}
                fullWidth
                sx={{ ...CampoPedidoInputStyle }}
            />
        </BoxComponent>

        <BoxComponent component="div" sx={{ ...CampoPedidoStyle, px: 0 }}>
            <LabelComponent htmlFor="bairro_cliente" sx={CampoPedidoLabelStyle}>
                Bairro
            </LabelComponent>
            <TextFieldComponent
                id="bairro_cliente"
                placeholder=""
                value={props.endereco?.bairro}
                onChange={e => props.onChange("bairro", e.target.value)}
                fullWidth
                sx={{ ...CampoPedidoInputStyle }}
                required
            />
        </BoxComponent>

        <BoxComponent component="div" sx={{ ...CampoPedidoStyle, px: 0 }}>
            <LabelComponent htmlFor="cep_cliente" sx={CampoPedidoLabelStyle}>
                CEP
            </LabelComponent>
            <TextFieldComponent
                id="cep_cliente"
                placeholder=""
                value={props.endereco?.cep}
                onChange={e => props.onChange("cep", e.target.value)}
                fullWidth
                sx={{ ...CampoPedidoInputStyle }}
            />
        </BoxComponent>

        <BoxComponent component="div" sx={{ ...CampoPedidoStyle, px: 0, width: "100%" }}>
            <BoxComponent component="div" sx={{}}>
                <LabelComponent htmlFor="cidade_cliente" sx={CampoPedidoLabelStyle}>
                    Cidade
                </LabelComponent>

                <Autocomplete
                    disablePortal
                    options={municipios}

                    getOptionLabel={(option) => {
                        return `${option.municipio}`
                    }}

                    value={municipio || null}

                    inputValue={props.endereco?.cidade || ""}

                    onInputChange={(_, newInputValue) => {
                        
                        props.onChange("cidade", newInputValue)
                        /*
                        setEndereco({
                            //...props.userData,
                            ...endereco,
                            cidade: newInputValue
                        } as UsuarioEnderecos);
                         */

                        if (newInputValue.length > 3) {                            
                            getMunicipios(newInputValue);
                        }
                    }}

                    onChange={(_, newValue) => {
                        setMunicipio(newValue || undefined);

                        props.onChange("cidade", newValue?.municipio);
                        props.onChange("estado", newValue?.uf);
                        /*
                        setEndereco({
                            ...endereco,
                            cidade: newValue?.municipio || "",
                            estado: newValue?.uf || ""
                        } as UsuarioEnderecos);
                         */
                    }}

                    isOptionEqualToValue={(option, value) =>
                        option.municipio === value.municipio
                    }

                    filterOptions={(x) => x}

                    renderInput={(params) => (
                        <TextField
                            {...params}
                            placeholder="Digite a cidade..."
                            variant="outlined"
                            sx={CampoPedidoInputStyle}
                            required
                        />
                    )}

                    ListboxProps={{
                        style: {
                            maxHeight: 200,
                            zIndex: 9999
                        }
                    }}

                    sx={{
                        width: "100%"
                    }}
                />
            </BoxComponent>
        </BoxComponent>
        <BoxComponent component="div" sx={{ ...CampoPedidoStyle, px: 0, width: "100%" }}>
            <BoxComponent component="div" sx={{ display: "flex", flexDirection: "column" }}>
                <LabelComponent htmlFor="uf_cliente" sx={CampoPedidoLabelStyle}>
                    Estado
                </LabelComponent>
                <SelectComponent
                    id="uf_cliente"
                    options={
                        ufs.map((element: UfDTO) => {
                            return {
                                label: element.nome,
                                value: element.sigla
                            }
                        })
                    }
                    onChange={(e: any) => {
                        /*
                        props.onChangeUserData({
                            ...props.userData,
                            estado: e
                        } as Usuario);
                         */
                        props.onChange("estado", e);
                    }}
                    value={props.endereco?.estado || ''}
                    MenuProps={{
                        disablePortal: true,
                        PaperProps: {
                            sx: {
                                zIndex: 2000
                            }
                        }
                    }}
                    sx={{ ...CampoPedidoInputStyle }}
                    required
                />
            </BoxComponent>
        </BoxComponent>

        <BoxComponent component="div" sx={{ ...CampoPedidoStyle, px: 0, flex: 2 }}>
            <LabelComponent htmlFor="ponto_referencia_cliente" sx={CampoPedidoLabelStyle}>
                Ponto de referência
            </LabelComponent>
            <TextFieldComponent
                id="ponto_referencia_cliente"
                value={props.endereco?.pontoReferencia || ""}
                onChange={e => props.onChange("pontoReferencia", e.target.value)}
                fullWidth
                sx={{ ...CampoPedidoInputStyle }}
                multiline
            />
        </BoxComponent>

        <BoxComponent component="footer" sx={{
            display: "flex", justifyContent: "space-between", width: "100%", gap: 1.5
        }}>
            <ButtonComponent id="botao-salvar-endereco"
                type="submit"
                sx={{
                    width: "100%",
                    height: '40px',
                    paddingTop: '8px',
                    paddingBottom: '8px',
                    borderRadius: '10.4px',
                    backgroundColor: '#E7000B',
                    opacity: 1,
                    boxSizing: 'border-box',
                    textTransform: 'none', // Evita que o MUI force caixa alta

                    // Fusão da Tipografia
                    fontFamily: '"Font 1", sans-serif',
                    fontWeight: 700,
                    fontSize: '16px',
                    lineHeight: '24px', // Mapeado do s+
                    letterSpacing: '0%',
                    color: '#FFFFFF', // Cor branca para contraste no fundo vermelho
                    textAlign: 'center',

                    '&:hover': {
                        backgroundColor: '#C40009', // Feedback visual para o hover
                    }
                }}
            >
                Salvar
            </ButtonComponent>

            <ButtonComponent id="botao-cancelar-endereco"
                sx={{
                    width: "100%",
                    height: '40px',
                    paddingTop: '8px',
                    paddingBottom: '8px',
                    borderRadius: '10.4px',
                    backgroundColor: '#D1D5DC',
                    opacity: 1,
                    boxSizing: 'border-box',
                    textTransform: 'none', // Evita que o MUI force caixa alta

                    // Fusão da Tipografia
                    fontFamily: '"Font 1", sans-serif',
                    fontWeight: 700,
                    fontSize: '16px',
                    lineHeight: '24px', // Mapeado do s+
                    letterSpacing: '0%',
                    textAlign: 'center',
                    color: "#101828",

                    '&:hover': {
                        backgroundColor: '#D1D5DF', // Feedback visual para o hover
                    }
                }}
                onClick={() => {
                    props.cancelaEndereco();
                }}
            >
                Cancelar
            </ButtonComponent>
        </BoxComponent>
    </BoxComponent>
}

export default NovoEnderecoFields;